import { useQuery } from '@apollo/client/react';
import { MY_VENDOR_CATALOG_ITEM } from 'api/graphql/catalog';

/** Loads a single catalog item (for the edit screen). */
export function useCatalogItem(catalogId) {
  const { data, loading, error, refetch } = useQuery(MY_VENDOR_CATALOG_ITEM, {
    variables: { catalogId },
    skip: !catalogId,
    fetchPolicy: 'cache-and-network',
  });

  return {
    item: data?.myVendorCatalogItem ?? null,
    loading,
    error,
    refetch,
  };
}
